import { defineComponent, onMounted, ref } from 'vue';
import { SkeletonType } from '@getaccept/fried-tofu';
export default defineComponent({
    name: 'PageSkeletonLoader',
    props: {
        pageHeight: {
            type: Number,
            required: true,
        },
        timeout: {
            type: Number,
            default: null,
        },
        timeoutMessage: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const timeoutCompleted = ref(false);
        onMounted(() => {
            if (props.timeout) {
                setTimeout(() => (timeoutCompleted.value = true), props.timeout);
            }
        });
        return {
            timeoutCompleted,
            SkeletonType,
        };
    },
});
